/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "8",
  cy: "8",
  r: "8",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2899_2195)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.6674 14.2505V13.0838C12.6674 12.465 12.4391 11.8715 12.0328 11.4339C11.6265 10.9963 11.0754 10.7505 10.5007 10.7505H6.1674C5.59276 10.7505 5.04166 10.9963 4.63533 11.4339C4.22901 11.8715 4.00073 12.465 4.00073 13.0838V14.2505",
  stroke: "white",
  strokeWidth: "1.10807",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.1674 8.41715C9.36402 8.41715 10.3341 7.37249 10.3341 6.08382C10.3341 4.79516 9.36402 3.75049 8.1674 3.75049C6.97078 3.75049 6.00073 4.79516 6.00073 6.08382C6.00073 7.37249 6.97078 8.41715 8.1674 8.41715Z",
  stroke: "white",
  strokeWidth: "1.10807",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), 'UserReviewIcon', {
  viewBox: '0 0 16 16'
});